import { Grid, Stack } from '@mui/material';
import { useTranslation } from '@chr/online-shared-ui-localizations';
import { CargoSummary } from '@/common/apis/dtos';
import { InformationDisplay } from '@/common/components/information-display/InformationDisplay';
import {
  formatNumber,
  removeExtraSpace,
  formatCargoSummaryProperties,
  mergeItemsIntoStrings
} from '@/common/utilities/display-utilities';
import { Dimensions } from './Dimensions';

interface PurchaseOrderItemsHeaderProps {
  cargoSummary?: CargoSummary;
  innerPackQty?: number;
}

export const PurchaseOrderItemsHeader = ({cargoSummary, innerPackQty }: PurchaseOrderItemsHeaderProps) => {
  const translate = useTranslation();
  
  if(!cargoSummary)
  {
    return null;
  }
  const cargoSummaryProperties = formatCargoSummaryProperties(cargoSummary);
  const dimensionsStrings = mergeItemsIntoStrings(cargoSummaryProperties.formattedDimensions);

  return (
    <Stack spacing={1}>
      <Grid container data-testid="cargo-details-summary" paddingTop='24px' spacing={2}>
        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={false}
            label={translate('Description of Goods')}
            text={removeExtraSpace(cargoSummary.descriptionOfGoods, '-')}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
              truncateText={false}
              label={translate('Marks and Numbers')}
              text={removeExtraSpace(cargoSummary.marks, '-')}
            />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={true}
            label={translate('Inner Pack Quantity')}
            text={innerPackQty}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={true}
            label={translate('Outer Pack Quantity')}
            text={cargoSummaryProperties.outerPackQty}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={true}
            label={translate('Pallets')}
            text={formatNumber(cargoSummary.pallets, 0, '-')}
          />
        </Grid>
      </Grid>

      <Grid container data-testid="cargo-details-summary" paddingTop='24px' spacing={2}>
      <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={true}
            label={translate('Total Weight')}
            text={cargoSummaryProperties.weight}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            truncateText={true}
            label={translate('Total Volume')}
            text={cargoSummaryProperties.volume}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
            data-testid={'hazmat-value'}
            label={translate('Hazmat')}
            textVariant={'subtitle2'}
            text={cargoSummary.isHazMat ? translate('Yes') : translate('No')}
          />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <InformationDisplay
              data-testid={'temp-control-value'}
              label={translate('Temperature controlled')}
              textVariant={'subtitle2'}
              text={cargoSummary.isTemperatureControlled ? translate('Yes') : translate('No')}
            />
        </Grid>

        <Grid item xs={12} sm={6} md>
          <Dimensions
            dimensionsStrings={dimensionsStrings}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
